import React, {Component} from "react";
import NewsHeader from "./NewsHeader";
import Xhr from "../../helpers/Xhr";
import Loading from "../../components/Loading";
import {Link, Redirect, withRouter} from "react-router-dom";
import SportsNews from "../../constants/SportsNews";
import {connect} from "react-redux";
import {addViewedNews} from "../../redux/actions/viewed-news";
import MomentDate from "../../components/MomentDate";

class NewsFull extends Component {

	state = {
		news     : [],
		fetching : true
	};

	componentDidMount() {
		const {type, slug, location : {search}} = this.props;

		Xhr.getNewsOne(slug, search).then((resp) => {
			if ( resp.data.news.length > 0 ) {
				// добавляем новость в хранилище просмотренных новостей
				this.props.addViewedNews(resp.data.news[0].id);
			}

			this.setState({
				news     : resp.data.news ? resp.data.news : [],
				fetching : false
			});
		});
	}

	goBack(event) {
		event.preventDefault();
		this.props.history.goBack();
	}

	render() {
		const {type, slug} = this.props;
		const data = this.state.news.length > 0 && this.state.news[0];
		const img = `http://old.maxline.by/assets/images/news/${data.img}`;

		if ( !this.state.fetching && !data ) {
			return (
				<div className="body__container__side-right bg-news">
					<div className="news">
						<div className="news__content">
							<div className="news__content-top">
								<div className="news__content-title">Новость недоступна</div>
							</div>
						</div>
					</div>
				</div>
			)
		}

		return (
			<div className="body__container__side-right bg-news">
				<div className="news">
					<NewsHeader type={type} isNewsFull={true}/>

					{this.state.fetching ? <Loading/> :
						<div className="news__content">
							<div className="news__content-top">
								<div className="news__content-back">
									<Link to={''} onClick={this.goBack.bind(this)}>
										<i className="fas fa-arrow-left"></i>
									</Link>
								</div>
								<div>
									<div className="news__content-sport"><a>{SportsNews[data.cat_id]}</a></div>
									<div className="news__content-date">
										<MomentDate date={data.date} withTitle={true}/>
									</div>
									<div className="news__content-title">{data.title}</div>
								</div>
							</div>
							<div className="news__content-data" dangerouslySetInnerHTML={{__html : data.text}}>

							</div>
						</div>}
				</div>
			</div>
		);
	}
}

export default withRouter(
	connect(
		state => ({}),
		dispatch => ({
			addViewedNews : (newsId) => {
				dispatch(addViewedNews(newsId));
			},
		})
	)(NewsFull)
);


// WEBPACK FOOTER //
// ./src/app/pages/News/NewsFull.js